<template>
<div>

<tabs id="portfolio" fill class="flex-column flex-md-row">
    <card shadow>

        <tab-pane title="Profile">
            <span slot="title">
                Eliza
            </span>
          <div class="row mt-5" style="margin: auto;">
              <photo imageBefore="img/portfolio/Eliza3.jpg" imageAfter="img/portfolio/Eliza3.jpg" title=""></photo>
              <photo imageBefore="img/portfolio/Eliza1.jpg" imageAfter="img/portfolio/Eliza1.jpg" title=""></photo>
              <photo imageBefore="img/portfolio/Eliza4.jpg" imageAfter="img/portfolio/Eliza4.jpg" title=""></photo>
              <hr>
          </div>
        </tab-pane>
        <tab-pane>
            <span slot="title">
                Karren
            </span>
            <div class="row" style="margin: auto;">
                <photo imageBefore="img/portfolio/kareen4.jpg" imageAfter="img/portfolio/kareen4.jpg" title=""></photo>
                <photo imageBefore="img/portfolio/kareen1.jpg" imageAfter="img/portfolio/kareen1.jpg" title=""></photo>
                <photo imageBefore="img/portfolio/kareen3.jpg" imageAfter="img/portfolio/kareen3.jpg" title=""></photo>
                <hr>
            </div>
        </tab-pane>


        <tab-pane>
             <span slot="title">
                Maayan
              </span>
          <div class="row mt-5" style="margin: auto;">
              <photo imageBefore="img/portfolio/Maayan4.jpg" imageAfter="img/portfolio/Maayan4.jpg" title=""></photo>
              <photo imageBefore="img/portfolio/Maayan3.jpg" imageAfter="img/portfolio/Maayan3.jpg" title=""></photo>
              <photo imageBefore="img/portfolio/Maayan1.jpg" imageAfter="img/portfolio/Maayan1.jpg" title=""></photo>
              <hr>
          </div>
        </tab-pane>
        <tab-pane>
             <span slot="title">
                Eva
              </span>
            <div class="row mt-5" style="margin: auto;">
                <photo imageBefore="img/portfolio/Eva-Bergeret1.jpg" imageAfter="img/portfolio/Eva-Bergeret1.jpg" title=""></photo>
                <photo imageBefore="img/portfolio/Eva-Bergeret3.jpg" imageAfter="img/portfolio/Eva-Bergeret3.jpg" title=""></photo>
                <photo imageBefore="img/portfolio/Eva-Bergeret2.jpg" imageAfter="img/portfolio/Eva-Bergeret2.jpg" title=""></photo>
                <hr>
            </div> 
        </tab-pane>
    </card>
</tabs>




    </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
import VueCompareImage from 'vue-compare-image';
import Photo from './Photo.vue';
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";

export default {
  components: {
    VueCompareImage,
    Modal,
    Photo,
    Tabs,
    TabPane
  },
  data() {
    return {
      modals: {
        modal1: false,
        modal2: false,
        modal3: false
      }
    };
  }
};
</script>
<style>
</style>
